import type { PickemsHit } from "components/layout/Search/Results/models/pickemsHit";
import React from "react";
import { Row } from "./Row";
import { ResultsInIndex } from "./ResultsInIndex";
import { Highlight } from "./Highlight";
import { useNormalisedHits } from "components/layout/Search/Results/hooks/useNormalisedHits";
import { PickemImage } from "sections/Pickems/components/PickemImage";
import { PickemsTransforms } from "selectors/PickemsTransforms";
import { useTitles } from "hooks/graphql/useTitles";
import { Icon } from "library";

export const PickemsResults = () => {
  const { items, results } = useNormalisedHits<PickemsHit>();
  const allTitles = useTitles();

  return (
    <ResultsInIndex
      indexName={`Pickems`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const categoryHighlight = item.normalisedHighlights?.category?.[0];
        const titleHighlight = item.normalisedHighlights?.title?.[0];
        return (
          <Row
            key={item.objectID}
            eventId={item.objectID}
            icon={
              item.cardImageUri || item.sports.length > 0 ? (
                <PickemImage
                  image={
                    item.cardImageUri
                      ? item.cardImageUri
                      : PickemsTransforms.getLogos(
                          item.sports.slice(0, 1),
                          allTitles,
                        )
                  }
                  altText={item.title}
                />
              ) : (
                <Icon type="pick" />
              )
            }
            title={
              <Highlight
                text={item.category}
                matchedWords={categoryHighlight?.matchedWords || []}
                html={categoryHighlight?.value || ""}
              />
            }
            subTitle={
              <Highlight
                text={item.title}
                matchedWords={titleHighlight?.matchedWords || []}
                html={titleHighlight?.value || ""}
              />
            }
            to={`/pickems/contest/${item.objectID}/pick/`}
          />
        );
      })}
    </ResultsInIndex>
  );
};
